// extracted by mini-css-extract-plugin
module.exports = {"card":"product_card__2OBA7"};